<template>
	<div
		class="square-box"
		:class="[assigned ? `square-box-${theme}` : 'square-box-disabled',
			{ 'cursor-pointer': clickable }]"
		@click="handleCLickItem">
		<div
			class="square-box-content tw-flex tw-justify-center tw-items-center"
			:class="[{ 'square-box-content-focused': focused && assigned }]"
		>
			<div>
				<check-icon class="check-icon" :color="checked || completed ? 'success' : ''"></check-icon>
			</div>
			<img :src="logo" alt="logo" :class="assigned ? 'square-box-img' : 'square-box-img-disabled'">
		</div>
	</div>
</template>

<script>
import CheckIcon from '@/modules/shared/components/icons/check-icon';

export default {
	name: 'simple-square-box',
	components: { CheckIcon },
	methods: {
		handleCLickItem() {
			if (this.assigned) {
				this.$emit('handle-click', 'assigned');
			} else {
				this.$emit('handle-click', 'no-assigned');
			}
		},
	},
	computed: {
	},
	props: {
		theme: {
			default: () => 'secondary',
		},
		logo: {
			default: () => '',
		},
		checked: {
			default: () => false,
		},
		completed: {
			default: () => false,
		},
		clickable: {
			default: () => false,
		},
		focused: {
			default: () => false,
		},
		assigned: {
			default: () => false,
		},
	},
};
</script>

<style lang="scss" scoped>
.square-box {
	border-radius: 10px;
	box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
	background-color: #fff;
	padding-bottom: 90%;
	position: relative;
	user-select: none;
	&-img {
		height: 25px;
		max-width: 90%;
	}
	&-img-disabled {
		filter: grayscale(100%);
		height: 25px;
	}
	&.square-box-primary {
		border: solid 2px var(--app-color-primary);
	}
	&.square-box-secondary {
		border: solid 2px var(--app-color-secondary);
		.square-box-content {
			&.square-box-content-checked {
				.content-name {
					color: var(--app-color-info);
				}
			}
			&.square-box-content-focused {
				border: solid 2px var(--app-color-secondary);
				border-radius: 10px;
			}
			.content-name {
				color: var(--app-color-info);
			}
		}
	}
	&.square-box-disabled {
		border: solid 2px color(gray-medium);
	}
	&-focused,
	&-content {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	&-focused {
		z-index: 1;
		background-color: var(--app-color-primary);
		.content-name {
			color: #fff !important;
			font-size: size(large);
			padding: 0 10px;
			line-height: 16px;
		}
	}
	&-content {
		padding: 20px 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		.content-name {
			color: var(--app-color-primary);
			font-size: size(medium);
			line-height: 14px;
		}
		.check-icon {
			position: absolute;
			top: 5px;
			right: 5px;
			width: 20px;
		}
		.check-active {
			position: absolute;
			top: -15px;
			left: 5px;
		}
		.content-actions {
			position: absolute;
			bottom: 5px;
			left: 0;
			right: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/external-integrations/simple-square-box.vue